import { ReactNode } from 'react';

import { cn } from 'support/helpers/cn/cn';

import { OrderFormAuthLayoutBackgroundContent } from './OrderFormAuthLayoutBackgroundContent/OrderFormAuthLayoutBackgroundContent';

type OrderFormAuthLayoutProps = {
  children: ReactNode;
  className?: string;
};

export function OrderFormAuthLayout({ className, children }: OrderFormAuthLayoutProps) {
  return (
    <div className="relative">
      <div className="fixed inset-0 h-screen overflow-hidden">
        <OrderFormAuthLayoutBackgroundContent />
      </div>
      <div
        className={cn(
          'fixed inset-0 z-10 flex min-h-screen flex-col items-center bg-gray-500/75 py-24 backdrop-blur-xs sm:px-6 lg:px-8',
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
}
